import { render, staticRenderFns } from "./ViewFaqsCategory.vue?vue&type=template&id=0854bea4"
import script from "./ViewFaqsCategory.vue?vue&type=script&lang=js"
export * from "./ViewFaqsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports